import React from "react";
import {connect} from "react-redux";
import {Button, Form, Input, Modal, Select, Space} from "antd";
import {displayErrors, normalizeEnum} from "../../libs/utils";
import {loadAllCompanies} from "../../actions/users";

class HostingAccountsTableFilter extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedFilter: 'COMPANY',
            filterValue: '',
            filterKey: 'owner',
            filterVisible: null,

            loadingCompanies: false,
            companiesLoaded: false,
            companies: [],
            selectedCompany: ''
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.showModal && !this.state.loadingCompanies && !this.state.companiesLoaded) {
            this.setState({ loadingCompanies: true })

            this.props.loadAllCompanies((res) => {
                this.setState({ loadingCompanies: false, companiesLoaded: true, companies: res.data.data });
            }, (err) => {
                if(typeof err.response !== 'undefined') {
                    this.setState({ loadingCompanies: false, companiesLoaded: true });
                    displayErrors(err.response.data);
                }
            });
        }
    }

    onChange(){
        let visibleValue = null;

        if(this.state.selectedFilter === 'COMPANY') {
            visibleValue = this.getCompanyName(this.state.filterValue);
        }

        this.props.onChange({
            name: normalizeEnum(this.state.selectedFilter),
            key: this.state.filterKey,
            value: typeof this.state.filterValue !== 'boolean' ? this.state.filterValue.trim() : this.state.filterValue,
            visible: visibleValue
        });
    }

    closeModal(apply = false, close = true) {
        this.setState({
            selectedFilter: 'COMPANY',
            filterValue: '',
            filterKey: 'owner',
            filterVisible: null,

            loadingCompanies: false,
            companiesLoaded: false,
            companies: [],
            selectedCompany: ''
        });

        if(close) {
            this.props.closeModal();
        }

        if(apply) {
            this.onChange();
        }
    }

    getCompanyName(guid) {
        let company = null;

        for(let i = 0; i < this.state.companies.length; i++) {
            if(this.state.companies[i].guid === guid) {
                company = this.state.companies[i];
                break;
            }
        }

        return company !== null ? company.name : '';
    }

    setFilter(name) {
        const filters = {
            STATUS: { key: 'status', value: 'ACTIVE' },
            COMPANY: { key: 'owner', value: '' },
            OWNER_EMAIL: { key: 'owner_email', value: '' },
            TYPE: { key: 'type', value: '' },
            LEGACY: { key: 'legacy', value: '' },
        };

        this.setState({ selectedFilter: name, filterKey: filters[name].key, filterValue: filters[name].value });
    }

    render() {
        const { Option } = Select;

        let content = '';

        if(this.state.selectedFilter === 'OWNER_EMAIL') {
            content = <Input value={this.state.filterValue}
                             onChange={(e) => this.setState({filterValue: e.target.value})}/>;

        } else if(this.state.selectedFilter === 'STATUS') {
            content = <Select onChange={(value) => this.setState({ filterValue: value })}>
                <Option value='ACTIVE'>Active</Option>
                <Option value='SUSPENDED'>Suspended</Option>
                <Option value='DELETED'>Deleted</Option>
            </Select>
        } else if(this.state.selectedFilter === 'TYPE') {
            content = <Select onChange={(value) => this.setState({ filterValue: value })}>
                <Option value='SHARED_HOSTING'>Shared hosting</Option>
                <Option value='CUSTOM_HOST'>Custom host</Option>
                <Option value='VPS_SERVER'>VPS server</Option>
                <Option value='DEDICATED_SERVER'>Dedicated server</Option>
            </Select>
        } else if(this.state.selectedFilter === 'LEGACY') {
            content = <Select onChange={(value) => this.setState({ filterValue: value })}>
                <Option value={true}>Yes</Option>
                <Option value={false}>No</Option>
            </Select>
        } else if(this.state.selectedFilter === 'COMPANY') {
            content = <Select
                filterOption={(input, option) => {
                    if(typeof option !== 'undefined') {
                        return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                    }
                    return false;
                }}
                loading={this.state.loadingCompanies}
                disabled={this.state.loadingCompanies}
                value={this.state.filterValue}
                showSearch
                allowClear
                onChange={(value) => this.setState({ filterValue: value })}>
                {this.state.companies.map((company, i) => {
                    return <Option key={i} value={company.guid}>{company.name}</Option>
                })}
            </Select>
        }

        return(
            <Modal
                title='Add Filter'
                destroyOnClose={true}
                onCancel={() => this.closeModal()}
                footer={<Space>
                    <Button onClick={() => this.closeModal()}>Close</Button>
                    <Button onClick={() => this.closeModal(true, false)}>Apply</Button>
                    <Button type='primary' onClick={() => this.closeModal(true, true)}>Apply & Close</Button>
                </Space>}
                open={this.props.showModal}>
                <Form layout='vertical'>
                    <Form.Item label='Select filter:'>
                        <Select value={this.state.selectedFilter} onChange={(value) => this.setFilter(value)}>
                            <Option value='STATUS'>Status</Option>
                            <Option value='TYPE'>Account type</Option>
                            <Option value='COMPANY'>Company</Option>
                            <Option value='OWNER_EMAIL'>Owner email</Option>
                            <Option value='LEGACY'>Is legacy</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item>
                        {content}
                    </Form.Item>
                </Form>
            </Modal>
        )
    }
}

export default connect(null, { loadAllCompanies })(HostingAccountsTableFilter);